import classNames from 'classnames';
import type { SVGProps } from 'react';
import styles from './Brynn.module.css';

/**
 * Brynn — the Revvly AI mark: the brand waveform plus a twinkling spark,
 * two-tone and theme-aware (navy line + mint spark in light; mint line +
 * bright-mint spark in dark). Ported from the design system (hifi/rv-lib.jsx
 * `Brynn` + rv-app.css `.rv-brynn`). Represents the assistant wherever an AI
 * mark is shown (sidebar entry, chat avatar, empty-state mark).
 *
 * Sized by the parent's `svg` rule (like a lucide icon), so it drops into the
 * sidebar NavRow and the chat avatar/mark chips without a size prop. Spreads
 * SVG props so callers can pass `aria-hidden`, etc.
 */
export function Brynn({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      // Stable global class so surfaces (e.g. the sidebar) can retint the mark
      // via --brynn-line / --brynn-spark without reaching into the CSS module.
      className={classNames('rv-brynn', styles.Brynn, className)}
      {...props}
    >
      <g transform="translate(4 6.5)">
        <path
          className={styles.Wave}
          d="M1.021 10.5625C4.31511 10.5625 5.13864 2.78709 6.7857 1.15015C8.43276 -0.0775511 8.84453 7.6979 10.0798 13.8364C10.9033 17.5195 12.1386 17.9287 13.3739 15.4733C15.021 12.1995 16.2563 5.24249 17.9033 4.42402C19.1386 4.01479 20.3739 8.51636 22.021 8.51636"
        />
        <path
          className={styles.Spark}
          d="M22 -5 L22.9 -2.3 L25.6 -1.4 L22.9 -0.5 L22 2.2 L21.1 -0.5 L18.4 -1.4 L21.1 -2.3 Z"
        />
      </g>
    </svg>
  );
}

export default Brynn;
